import { useState } from "react";
import SideBar from "../../../components/SideBar";
import Navigation from "../../../components/Navigation";
import Footer from "../../../components/Footer";
import LogOutModal from "../../../components/modals/LogOutModal";
import ContactUsModal from "../../../components/modals/ContactUsModal";
import DownloadStatement from "../../../components/modals/clients/DownloadStatement";
import StatementsTable from "../../../components/tables/StatementsTable";

const Statements = () => {
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setIsLogOutModalOpen(!isLogOutModalOpen);
  };

  const toggleContactUsModal = () => {
    setIsContactUsModalOpen(!isContactUsModalOpen);
  };

  const toggleDownloadModal = () => {
    setOpenDownloadModal(!openDownloadModal);
  };

  const pageTitle = "Statements";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Statements" }];

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-primary-light">
      <SideBar
        options={{
          toggleLogOutModal,
          toggleContactUsModal,
        }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        {/* navigation */}
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
          <StatementsTable toggleDownloadModal={toggleDownloadModal} />
          <Footer />
        </div>
      </main>

      <LogOutModal
        isOpen={isLogOutModalOpen}
        setIsOpen={setIsLogOutModalOpen}
      />
      <ContactUsModal
        isOpen={isContactUsModalOpen}
        setIsOpen={setIsContactUsModalOpen}
      />

      <DownloadStatement
        options={{
          openDownloadModal,
          setOpenDownloadModal,
        }}
      />
    </div>
  );
};

export default Statements;
